import { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import NavBar from './NavBar';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { theme } = useTheme();

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998,
            transition: 'opacity 0.3s ease',
            opacity: isOpen ? 1 : 0,
          }}
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '280px',
          height: '100vh',
          background: theme.colors.bgSecondary,
          borderRight: `1px solid ${theme.colors.border}`,
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          zIndex: 999,
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease',
          overflowY: 'auto',
        }}
      >
        {/* Close Button */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '8px'
        }}>
          <h2 style={{ 
            color: theme.colors.textPrimary, 
            margin: 0, 
            fontSize: '20px',
            fontWeight: 600
          }}>
            My Portal
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: theme.colors.textSecondary,
              fontSize: '28px',
              cursor: 'pointer',
              padding: '4px 8px',
              lineHeight: '1',
              transition: 'color 0.2s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.colors.textPrimary}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.colors.textSecondary}
          >
            ×
          </button>
        </div>

        {/* Navigation */}
        <NavBar />
      </div>
    </>
  );
}
